const DAYS_OF_WEEK = [
    "Sun",    // 0
    "Mon",    // 1
    "Tue",   // 2
    "Wed", // 3
    "Thu",  // 4
    "Fri",    // 5
    "Sat"   // 6
];

export { DAYS_OF_WEEK };